export default function(container, event) {
  let focusElements = container.querySelectorAll("a, input, select, button");

  const firstElem = focusElements[0];
  const lastElem = focusElements[(focusElements.length - 1)];

  // Focus on the first element if an event isn't provided
  if (typeof event === 'undefined') {
    firstElem.focus()
    return;
  }

  if (event.target == firstElem && event.shiftKey) {
    event.preventDefault();
    lastElem.focus();
  } else if (event.target == lastElem && !event.shiftKey) {
    event.preventDefault();
    firstElem.focus();
  }
}
